module.exports = __webpack_public_path__ + "assets/img/786d-sl.svg";